import {computed, Injectable, signal} from '@angular/core';
import {
  EnquiriesApiService,
  Enquiry,
  EnquiryStatus,
  UpdateEnquiryDto
} from "@app/areas/crm/enquiries/services/enquiries-api.service";
import {take, tap} from "rxjs/operators";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class EnquiriesService {
  enquiries = signal<Enquiry[]>([])
  loading = signal(false)

  badgeCount = computed(() => {
    return this.enquiries().filter(e => e.status === EnquiryStatus.PATIENT_SUBMITTED || e.status === EnquiryStatus.OPEN).length;
  })

  constructor(private api: EnquiriesApiService) {
  }

  refresh(): void {
    this.loading.set(true)
    this.api.list({pageSize: 100})
      .pipe(take(1))
      .subscribe({
        next: res => {
          this.enquiries.set(res.items)
          this.loading.set(false)
        },
        error: _err => {
          this.enquiries.set([])
          this.loading.set(false)
        }
      })
  }

  updateStatus(id: string, newStatus: EnquiryStatus): Observable<Enquiry> {
    const update: UpdateEnquiryDto = {
      enquiry: {
        id,
        status: newStatus
      },
      updateMask: { paths: ['status'] }
    }

    return this.api.update(id, update)
      .pipe(
        take(1),
        tap((res: Enquiry) => {
          console.log('replacing', res)
          // Optionally replace the specific enquiry with the API response
          this.enquiries.update(list =>
            list.map(e => (e.id === res.id ? res : e))
          );
        })
      )
  }
}
